import React, { useState, useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  InputAdornment,
  TextField,
} from '@mui/material'

interface DuplicateTranscriptModalProps {
  open: boolean
  onClose: () => void
  onConfirm: (newName: string) => void
  defaultName?: string
  loading?: boolean
  /** True while the transcript being duplicated is still being fetched. */
  loadingTranscript?: boolean
}

const DuplicateTranscriptModal: React.FC<DuplicateTranscriptModalProps> = ({
  open,
  onClose,
  onConfirm,
  defaultName = '',
  loading = false,
  loadingTranscript = false,
}) => {
  const [name, setName] = useState(defaultName)

  useEffect(() => {
    if (open) setName(defaultName)
  }, [open, defaultName])

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Duplicate Transcript</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          label="Transcript Name"
          type="text"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          disabled={loading || loadingTranscript}
          helperText={loadingTranscript ? 'Loading transcript...' : undefined}
          InputProps={{
            endAdornment: loadingTranscript ? (
              <InputAdornment position="end">
                <CircularProgress size={20} />
              </InputAdornment>
            ) : undefined,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={() => onConfirm(name)}
          disabled={loading || loadingTranscript || !name.trim()}
          variant="contained"
        >
          {loading ? 'Duplicating...' : 'Duplicate'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DuplicateTranscriptModal
